const textFromDetail = (detail) => {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (typeof item === 'string') return item;
        if (item && typeof item.msg === 'string') return item.msg;
        if (item && typeof item.message === 'string') return item.message;
        if (item && typeof item.error === 'string') {
          return typeof item.file === 'string' ? `${item.file}: ${item.error}` : item.error;
        }
        return '';
      })
      .filter(Boolean)
      .join(' · ');
  }
  if (detail && typeof detail === 'object') {
    const errors = Array.isArray(detail.errors) ? textFromDetail(detail.errors) : '';
    const files = Array.isArray(detail.files) ? textFromDetail(detail.files) : '';
    return [typeof detail.message === 'string' ? detail.message : '', errors, files]
      .filter(Boolean)
      .join(' · ');
  }
  return '';
};

export function formatApiError(error, fallback = 'Request failed') {
  return textFromDetail(error?.response?.data?.detail) || fallback;
}
